import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ChangePasswordButton } from './ChangePasswordButton';
import { Information, Field } from '@/components/Settings/Account/components';

export function ChangePassword() {
	return (
		<Row gutter={[0, 16]}>
			<Col span={24}>
				<Field>{I18n.get('Password')}</Field>
			</Col>
			<Col span={24}>
				<Information>************</Information>
			</Col>
			<Col span={24}>
				<ChangePasswordButton />
			</Col>
		</Row>
	);
}
